import type { ConverterExcecaoDto, ItemTributoResponse } from '@triade/contracts';

/**
 * Sessao 51b (U8): colunas antigas do item (PIS/COFINS/ICMS/ISS) com valor que a tabela estruturada NAO usa, quando o campo de
 * excecao correspondente esta vazio. So le o texto da taxa (fracao): nenhuma aliquota e somada, comparada ou calculada aqui.
 */
export type CampoColunaAntiga = ConverterExcecaoDto['campos'][number];

const COLUNAS: ReadonlyArray<{ campo: CampoColunaAntiga; exc: 'excPis' | 'excCofins' | 'excIcms' | 'excIss' }> = [
  { campo: 'pis', exc: 'excPis' },
  { campo: 'cofins', exc: 'excCofins' },
  { campo: 'icms', exc: 'excIcms' },
  { campo: 'iss', exc: 'excIss' },
];

/** Taxa em fracao com algum digito diferente de zero ("0.01650000" sim; "0.00000000" nao). */
export function taxaPreenchida(fracao: string | null | undefined): boolean {
  return /[1-9]/.test(fracao ?? '');
}

/** Colunas antigas com valor e sem excecao do item (vazio = null/ausente; "0" ja e um valor). */
export function colunasAntigasPendentes(v: ItemTributoResponse | null | undefined): CampoColunaAntiga[] {
  if (!v) return [];
  return COLUNAS.filter(({ campo, exc }) => taxaPreenchida(v[campo]) && !v[exc]).map(({ campo }) => campo);
}
